import { TranslationService } from "@services/translation.service";

export function translateFilter(translationService: TranslationService ) {
    return (input: string, params?: any) => {
        return translationService.t(input, params);
    }
}
